<template>
  <div class="simulation-hero-container">
    <div class="simulation-hero with-project">
      <h1>
        Calculer le
        <strong>rendement d'un investissement locatif</strong>
      </h1>
      <!-- Le formulaire du simulateur et, à côté, « Écrire mon projet » (ouvert à tous
           depuis le 27/10/2026). Rendus côté serveur : pas de saut de mise en page. -->
      <div class="cards">
        <SimulationFinForm class="form" />
        <SimulationProjectDescription />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.simulation-hero-container {
  .app-padding();
  background-color: var(--ds-color-primary-25);
  padding-top: 15px;
  padding-bottom: 10px;

  .simulation-hero {
    max-width: 1700px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .form {
      margin: 24px 0;
      box-shadow: rgba(0, 0, 0, 0.04) 0 2px 10px 0;
    }

    h1 {
      text-align: center;
      font-size: var(--ds-font-xl);
      margin: 0;

      strong {
        color: var(--ds-color-primary-100);
        font-weight: inherit;
      }
    }

    // Le formulaire et la carte « Écrire mon projet » : côte à côte sur grand écran, l'un
    // sous l'autre sinon. Le formulaire devient fluide (715 px fixes ailleurs), comme sur
    // la page de vente du simulateur.
    &.with-project .cards {
      width: 100%;
      max-width: 1240px;
      margin: 24px 0;
      display: grid;
      grid-template-columns: minmax(0, 715px);
      justify-content: center;
      gap: 24px;
      align-items: start;

      .form {
        margin: 0;
      }

      :deep(.fin-form) {
        width: 100%;
      }

      @media (min-width: 1280px) {
        grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
      }
    }
  }

  @media @bp-lg {
    .simulation-hero {
      h1 {
        font-size: 33px;
        font-weight: var(--ds-weight-semi-bold);
      }
    }
  }

  @media @bp-xlg {
    padding-top: 50px;
  }
}
</style>
